import { useUserStore } from '@/stores/user';
import type { Profile } from '@amministro-io-packages/auth-interfaces';
import { computed, toRefs } from 'vue';
import { useRoute } from 'vue-router';

export const useProfiles = <T extends Profile = Profile>(id?: string) => {
  const route = useRoute();
  const _id = id ?? route.params.idElement;

  const { profiles } = toRefs(useUserStore());
  const profile = computed<T | undefined>(() => profiles.value?.find((pr) => pr.profile_id === _id) as T);

  return { profile, profiles };
};
